class YoursizeService {
    /*@ngInject*/
    constructor($log, $http, $timeout, $rootScope, CommonService) {
        this.$log = $log;
        this.$http = $http;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.commonService = CommonService;
        this.enabled = false;
        this.isLoggedInCustomer = false;
        this.footScanMissing = false;
        this.avatars = [];
        this.productCode = null;
        this.selectedAvatar = {};

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.enabled = this.commonService.getPersonalizeRequestResponse().isMatchingEnabled;

            this.isLoggedInCustomer = this.commonService.getPersonalizeRequestResponse().isHardLoggedIn;

            if (this.isLoggedInCustomer && this.enabled) {
                this.fetchAvatarsAndMatch();
            }
        });
    }

    setState(targetState) {
        if (!this.isLoggedInCustomer || this.footScanMissing) {
            return;
        }
        let url = this.commonService.getBaseUrl() + '/ajax/product/match/toggle/' + targetState;
        this.$http.post(url)
            .then((response) => {
                this.enabled = response.data.value;
                if (this.enabled) {
                    this.fetchAvatarsAndMatch();
                }
            }, (error) => {
                this.$log.error('YoursizeService toggle matching: ' + error.status + ' ' + error.statusText);
            });
    }

    matchAvatar(avatar) {
        if (this.isLoggedInCustomer && this.enabled) {
            this.selectedAvatar = avatar;
            this.fetchAvatarsAndMatch();
        }
    }

    fetchAvatarsAndMatch() {

        let url = this.commonService.getBaseUrl() + '/ajax/product/match?productCode=' + this.productCode;
        if (this.selectedAvatar && this.selectedAvatar.avatar) {
            url = url + '&avatar=' + this.selectedAvatar.avatar.deviceId;
        }
        this.$http.get(url, null)
            .then((response) => {
                if (!response.data.footScansAvailable) {
                    this.enabled = false;
                    this.footScanMissing = true;
                } else {
                    this.avatars = response.data.avatars;
                    for (let avatar of this.avatars) {
                        if (avatar.match != null) {
                            this.selectedAvatar = avatar;
                            break;
                        }
                    }
                }

                this.$rootScope.$broadcast('fetchAvatarsDone');
            }, (error) => {
                this.$log.error('YoursizeService fetch avatars: ' + error.status + ' ' + error.statusText);
            });
    }

    setProductCode(productCode) {
        this.productCode = productCode;
    }

    getAvatars() {
        return this.avatars;
    }

    getSelectedAvatar() {
        return this.selectedAvatar;
    }

    isEnabled() {
        return this.enabled;
    }

    isLoggedIn() {
        return this.isLoggedInCustomer;
    }

    isFootScanMissing() {
        return this.footScanMissing;
    }

}

export default YoursizeService;
